/**
 * Represents a card with a specific template and associated statistics.
 * @template T The type of card template.
 */
import { CardTemplate } from '@longtail-education/superprep-data-model-frontend'
import { CardStats } from '@longtail-education/superprepstudy-data-model-frontend'

export class Card<T extends CardTemplate> {
  /** The ID of the card. */
  readonly id!: string
  /** The template of the card. */
  readonly template!: T
  /** The statistics associated with the card. */
  readonly stats!: CardStats

  /**
   * Constructs a new Card instance.
   * @param template The template of the card.
   * @param stats The statistics associated with the card (optional).
   */
  constructor(template: T, stats: CardStats | undefined) {
    const id = template.id ?? stats?.cardId
    if (!id) { return }
    this.id = id
    this.template = template
    this.stats = stats ?? new CardStats(this.id)
  }
}
